import { themes } from "@/mocks/content";
import { Reveal, SectionHeading } from "./common";

export default function Themes() {
  return (
    <section id="themes" className="section-anchor w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
        <Reveal>
          <SectionHeading
            eyebrow="主题解读"
            title="藏在故事背后的六组追问"
            desc="与其说这是一部讲「发生了什么」的作品，不如说它在追问：当善意、亲情与内心的冲动撞在一起，人该如何自处。"
          />
        </Reveal>

        <div className="mt-8 md:mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5">
          {themes.map((theme, i) => (
            <Reveal key={theme.title} delay={i * 50}>
              <div className="h-full rounded-lg bg-background-100 border border-background-200 p-5 md:p-6">
                <span className="service-icon-wrap rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                  <i className={`${theme.icon} text-lg`}></i>
                </span>
                <h3 className="mt-4 font-heading text-base md:text-lg font-semibold text-foreground-950">
                  {theme.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {theme.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}